import { ReactElement } from 'react'
import styled, { ThemeProvider } from 'styled-components'

import { handleComponentStateTheme } from 'utils/theme'
import { IItineraryStateProps } from './types'

const ItineraryStateContainer = styled.div`
  background-color: ${({ theme }): string => theme.backgroundColor};
  border: 1px solid ${({ theme }): string => theme.borderColor};
  border-radius: 24px;
  color: ${({ theme }): string => theme.color};
  display: inline-flex;
  font-weight: 500;
  padding: 4px 8px;
  transition: 0.3s;
  width: fit-content;
`

const ItineraryState = ({ className, label, state = 'default' }: IItineraryStateProps): ReactElement => {
  return (
    <ThemeProvider theme={handleComponentStateTheme(state)}>
      <ItineraryStateContainer className={className}>{label}</ItineraryStateContainer>
    </ThemeProvider>
  )
}

export default ItineraryState
